import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { useState } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _Heading from '../Heading/index.js';
import _Link from '../Link/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var StyledContentBlockDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n  min-height: 550px;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n    min-height: auto;\n  }\n"])), function (_ref) {
  var imgSide = _ref.imgSide;
  return imgSide === 'left' ? 'row' : 'row-reverse';
});
var StyledContentBlockText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column\n  align-items: left;\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n  position: relative;\n  max-width: 50%;\n  padding-top: 8rem;\n  padding-right: 8rem;\n  padding-bottom: 8rem;\n\n  padding-left: ", ";\n\n  @media (max-width: 800px) {\n    max-width: 100%;\n    width: 100%;\n    padding-top: 4rem\n    padding-right: 0px;\n    padding-left: 0px;\n    padding-bottom: 4rem;\n}\n"])), function (_ref2) {
  var imgSide = _ref2.imgSide;
  return imgSide === 'left' ? '8rem' : '0px';
});
var StyledImageDiv = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n  max-width: 50%;\n  width: 50%;\n  @media (max-width: 800px) {\n    min-height: 300px;\n    max-width: 100%;\n    width: 100%;\n  }\n"])), function (_ref3) {
  var _ref3$backgroundColor = _ref3.backgroundColor,
    backgroundColor = _ref3$backgroundColor === void 0 ? 'accent1' : _ref3$backgroundColor,
    theme = _ref3.theme,
    isImageLoaded = _ref3.isImageLoaded;
  return isImageLoaded ? 'transparent' : theme && theme.palette[backgroundColor];
});
var StyledBlockImage = styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n  max-width: 100%;\n  width: 100%;\n  color: transparent;\n"])));
var StyledHeading = styled(_Heading)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  && {\n    font-weight: 400;\n  }\n"])));
var StyledFooterContentContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-top: 0.75rem;\n  font-size: 0.75rem;\n  align-self: ", ";\n  color: ", ";\n"])), function (_ref4) {
  var isImageLoaded = _ref4.isImageLoaded;
  return isImageLoaded ? 'flex-start' : 'center';
}, function (_ref5) {
  var isImageLoaded = _ref5.isImageLoaded;
  return isImageLoaded ? 'inherit' : 'white';
});
var ContentBlock = function ContentBlock(_ref6) {
  var _ref6$theme = _ref6.theme,
    theme = _ref6$theme === void 0 ? themes.secureSite : _ref6$theme,
    _ref6$imgSide = _ref6.imgSide,
    imgSide = _ref6$imgSide === void 0 ? 'left' : _ref6$imgSide,
    _ref6$backgroundColor = _ref6.backgroundColor,
    backgroundColor = _ref6$backgroundColor === void 0 ? 'accent1' : _ref6$backgroundColor,
    imageAltText = _ref6.imageAltText,
    imageUrl = _ref6.imageUrl,
    heading = _ref6.heading,
    text = _ref6.text,
    link = _ref6.link,
    linkText = _ref6.linkText,
    linkTestID = _ref6.linkTestID,
    footerContent = _ref6.footerContent;
  // show background color if image isn't loaded
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isImageLoaded = _useState2[0],
    setIsImageLoaded = _useState2[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledContentBlockDiv, {
    imgSide: imgSide
  }, /*#__PURE__*/React.createElement(StyledImageDiv, {
    theme: theme,
    isImageLoaded: isImageLoaded,
    backgroundColor: backgroundColor
  }, !isImageLoaded && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      color: 'black',
      backgroundColor: 'white'
    }
  }, imageAltText), /*#__PURE__*/React.createElement(StyledBlockImage, {
    "data-testid": 'primary-block-image',
    alt: imageAltText,
    src: imageUrl,
    onLoad: function onLoad() {
      return setIsImageLoaded(true);
    }
  }), footerContent && /*#__PURE__*/React.createElement(StyledFooterContentContainer, {
    isImageLoaded: isImageLoaded
  }, footerContent)), /*#__PURE__*/React.createElement(StyledContentBlockText, {
    imgSide: imgSide
  }, heading && text && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    theme: themes.secureSite,
    color: 'black',
    elemType: 'h3',
    elemStyle: 'h2'
  }, heading), /*#__PURE__*/React.createElement("p", null, text), ' '), typeof link === 'string' && linkText && /*#__PURE__*/React.createElement(_Link, {
    href: link,
    "data-testid": linkTestID
  }, linkText, ' ', /*#__PURE__*/React.createElement(_Icon, {
    style: {
      marginLeft: '0.25rem'
    },
    name: 'chevron-right-solid',
    color: 'secondary'
  })) || link)));
};
// exported component is wrapped with the default theme
var _ContentBlock = withDefaultTheme(ContentBlock);

export default _ContentBlock;
